import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { isADITenant, isIntelTenant } from 'src/app/services/common/common.service'
import { LocalStorageService } from '../services/common/local-storage.service'

export const rootTenantRedirectGuard: CanActivateFn = (_route, _state, hostnameOverride?: string) => {
  const router = inject(Router)

  if (isIntelTenant(hostnameOverride)) {
    router.navigate(['/login', 'INTEL'])
    LocalStorageService.set('companyDomain', 'INTEL')
    return false
  }

  if (isADITenant(hostnameOverride)) {
    router.navigate(['/login', 'ADI'])
    LocalStorageService.set('companyDomain', 'ADI')
    return false
  }

  return true
}
